import { HandheldPinkAppVersionInfoService, NakiHandheldPinkBetaChannelService } from "common/services";
import AppReleaseRouteStore from "./AppReleaseRouteStore";

class HandheldPinkAppReleaseRouteStore extends AppReleaseRouteStore {
    constructor(rootStore) {
        super(rootStore, HandheldPinkAppVersionInfoService, NakiHandheldPinkBetaChannelService);
    }
}

export default HandheldPinkAppReleaseRouteStore;
